export const decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionEligibleBaseCreatives =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_variants/dimensions/:dimension/eligible_base_creatives";
